export default {
  affiliate: {
    // Main navigation
    title: 'Afiliado',
    cantFindQuestion: 'Não encontra a pergunta?',
    onlineService: 'Serviço Online',
    dashboard: 'Painel',
    myRewards: 'Minhas Recompensas',
    // My Price 页（照 Figma 重做）
    team: 'Equipe',
    myPrice: 'Meu Prêmio',
    rule: 'Regra',
    checkOutRules: 'Confira Nossas Regras',
    rewardsOverview: 'Visão geral das recompensas',
    rewardAmount: 'Valor Da Recompensa',
    date: 'Data',
    selectDate: 'Selecionar data',
    commissionRewards: 'Recompensas De Comissão',
    noReferralRewards: 'Ainda não há recompensas de indicação \nConvide amigos para começar a ganhar recompensas',
    noCommissionRewards: 'Ainda não há recompensas de comissão \nComece a ganhar convidando amigos',
    inviteFriendsToEarnTitle: 'Convide Amigos Para Ganhar',
    moreFriendsMoreRewards: 'Mais amigos, mais recompensas, potencial de ganhos ilimitado !',
    inviteNow: 'Convidar Agora',
    invitationRewards: 'Recompensas de Convite',
    rules: 'Regras',

    // Team Info
    teamData: 'Dados da Equipe',
    details: 'Detalhes',
    totalValidFriends: 'Total de amigos válidos:',
    todayTotalWager: 'Apostas totais de hoje:',
    rewards: 'Recompensas',

    // Commission rates
    inviteFriendsCommissionUpTo: 'Comissão de Convite de Amigos Até',
    expandTeamBonus: 'Bônus de Expansão de Equipe',
    maxLevelCommission: 'Comissão de Nível Máximo',
    inviteFriendsCommission: 'Comissão de Convite de Amigos',
    maxPerformanceCommission: 'Comissão de Desempenho Máximo',
    unlimitedAgent: 'Agente Ilimitado',
    unlimitedCommission: 'Comissão Ilimitada',
    commissionRate: 'Taxa de Comissão',

    // Team Invite Friends
    inviteFriendsToEarn: 'CONVIDE AMIGOS PARA GANHAR',
    link: 'Link',
    code: 'Código',
    inviteFriends: 'Convidar amigos',
    share: 'Compartilhar',

    // Withdrawal Rewards
    totalCommission: 'Comissão Total',
    claim: 'Reivindicar',
    bettingBonus: 'Bônus de Apostas',
    depositBonus: 'Bônus de Depósito',
    todayReceived: 'Recebido Hoje',

    // Live Rewards
    liveRewards: 'Recompensas ao Vivo',
    sendTotalCommission: 'Enviar comissão total',

    // Team Data Details
    totalRewardsReceived: 'Comissão Total',
    todayInviteFriends: 'Amigos Convidados Hoje',
    todayDepositFriends: 'Amigos com Depósito Hoje',
    depositFriends: 'Amigos com Depósito',
    validFriends: 'Amigos Válidos',

    // Dialogs
    howMakeFriendsSubordinates: 'Como tornar amigos seus subordinados:',
    shareInvitationLink: 'Compartilhe seu link de convite para que eles se registrem.',
    shareInvitationCode: 'Compartilhe seu código de convite para que eles insiram durante o registro.',
    shareQRCode: 'Compartilhe seu código QR para que eles escaneiem e se registrem.',
    depositFriendsDescription: 'Quando seus amigos subordinados depositarem dinheiro com sucesso, eles se tornarão amigos depositantes.',
    howMakeFriendsValidUsers: 'Como fazer seus amigos se tornarem usuários válidos:',
    successfullyInviteFriends: 'Convide amigos para se inscrever com sucesso.',
    cumulativeDepositsReach: 'Seus depósitos cumulativos atingem 10.00 USDT.',
    cumulativeValidBetsReach: 'Suas apostas válidas cumulativas atingem 50.00 USDT.',
    thenBecomeValidUsers: 'Então, eles se tornarão usuários válidos.',

    // Share Dialog
    shareTitle: 'Compartilhar',
    player: 'Jogador',
    saveImage: 'Salvar imagem',
    saveImageSuccess: "Imagem salva",
    saveImageFailed: "Falha ao salvar, tente novamente",
    copy: 'Copiar',
    copied: 'Copiado!',

    // Received/Withdraw
    received: 'Recebido',
    withdraw: 'Sacar',
    history: 'Histórico',
    referralRewards: 'Recompensas de Indicação',
    commission: 'Comissão',
    depositRebate: 'Reembolso de Depósito',
    levelUpRewards: 'Recompensas de Subida de Nível',
    loading: 'Carregando...',
    noMoreRecords: 'Não há mais registros',
    loadMore: 'Carregar mais',
    pending: 'Pendente',
    paid: 'Pago',
    rejected: 'Rejeitado',
    unknown: 'Desconhecido',
    upgradeReward: 'Bônus de Upgrade',
    cancelled: 'Cancelado',
    receiving: 'Recebendo',
    failed: 'Falhou',
    expired: 'Expirado',

    // History Dialog
    pickDate: 'Escolha uma data',
    select: 'Selecionar',
    chooseBonus: 'Escolher bônus',
    all: 'Todos',

    // Invitation Rewards Page
    inviteFriendToGet: 'Convide um amigo para ganhar',
    yourFriendGet: 'Seu amigo recebe',
    inviteFriendsEarnRewards: 'Convide amigos e ganhe recompensas',
    dailyInvitations: 'Convites diários',

    // Rules - How to earn
    howToEarnAffiliateRewards: 'Como ganhar recompensas de afiliado?',
    shareToFriends: 'Compartilhar com amigos',
    shareReferralLink: 'Compartilhe seu link de indicação, código ou QR code com seus amigos',
    friendsSignUpDeposit: 'Amigos se inscrevem e depositam',
    inviteFriendsRegisterDeposit: 'Convide amigos para se registrar no AFUN e fazer o primeiro depósito.',
    getUpTo: 'Receba até',
    earnBigRewards: 'Ganhe recompensas e comissões quando amigos apostam, depositam e alcançam VIP.',
    noticeEnsureCorrect: 'Aviso: Certifique-se de que o link de convite, código QR ou código esteja correto.',

    // Rules - Commission Work
    howCommissionWork: 'Como funciona a Comissão?',
    agentRatingDescription: 'Descrição da Classificação do Agente',
    you: 'VOCÊ',
    commissionDescription: 'Ganhe comissão dos depósitos e apostas dos seus Amigos B, C, D e além. Veja a tabela à direita para as taxas de comissão.',
    claimConditions: 'Condições de reivindicação',
    teamLevel: 'Nível da Equipe',
    earnUpTo: "Ganhe até",
    expandYourTeam: "Expanda Sua Equipe",
    earnAnExtra: "Ganhe um Extra",
    upgradeAgentLevel: "Aumente Seu Nível de Agente",
    todayValidFriends: "Amigos válidos de hoje",
    inviteFriendsAndEarn: "CONVIDE AMIGOS E GANHE",
    joinUsGetCommission: "Junte-se a nós e ganhe mais comissão",
    shareLinkInviteDesc: "Compartilhe o link com seus amigos e convide-os a se registrar e depositar. Você e seu amigo podem receber comissões compartilhadas.",
    totalSize: 'Tamanho Total',
    teamWager: 'Apostas da Equipe',
    rebateRewardVary: 'Recompensa de Reembolso e Recompensa de Recarga variam com base no nível da sua equipe naquele dia.',
    teamSizeDescription: 'Tamanho da equipe: O número de usuários válidos que você possui atualmente.',
    teamBettingDescription: 'Apostas da equipe: O número total de apostas que seus subordinados fazem em um dia.',
    teamCommissionTitle: 'TEAM COMMISSION\n\nEarn from every deposit and every bet across your network.',
    teamCommissionMainTitle: 'COMISSÃO DE EQUIPE',
    teamCommissionSubTitle: 'Ganhe com cada depósito e\ncada aposta da sua rede.',
    friendsBettingRebate: 'Friends betting rebate commission',
    commissionCalcEvery24h: 'The system calculates commissions every 24 hours.',
    earnCommissionWhenBet: 'You earn a commission when your friends or their friends place bets.',
    commissionSameIpRule: 'Commissions cannot be released to accounts that share the same IP address, device, or shared account, regardless of whether they are on public networks (such as schools, libraries, and offices) or private networks (such as homes and apartments). To receive commissions, the referred account must be on a unique IP address, not shared with other accounts on the platform.',
    commissionFormula: 'Commission = total team wager * 1% * commission rate.',
    commissionRangeDescription: 'You can receive a certain percentage of commission from all the wager and recharge amount made by A, B, C, D, E and F. Please refer to the following diagram for specific commission rates.',
    commissionSupportGames: 'Commission Support Games',

    // Rules - Invitation Rewards
    inviteFriendsBothReceive: 'Convide amigos e ambos receberão recompensas',
    inviteRegisterReceive: 'Convide amigos para se registrar com sucesso e receba',
    friendDepositWagerUnlock: 'Quando seu amigo depositar 10.00 USDT e apostar 50.00 USDT, você desbloqueia uma recompensa de 3.00 USDT e seu amigo recebe 2.00 USDT.',

    // Team Data Dialog / Rewards 补充
    recentInviteFriends: 'Amigos Convidados Recentes',
    recentDepositFriends: 'Amigos com Depósito Recentes',
    today: 'Hoje',
    yesterday: 'Ontem',
    thisMonth: 'Este mês',
    friendsData: 'Dados dos Amigos',
    joinDate: 'Data de Entrada',
    search: 'Pesquisar',
    level: 'Nível',
    tier: 'Nível',
    affiliateTreasureBox: 'Baú do Tesouro de Afiliados',
    referralRewardsDesc: 'Quando você convida amigos para se registrar, tanto você quanto seus amigos receberão bônus generosos.',
    commissionDesc: 'Você e sua equipe trabalham juntos para alcançar seus objetivos e ganhar comissões generosas.',
    affiliateTreasureBoxDesc: 'Convide amigos para ganhar bônus por marcos',
  }
};
